export default function Home() {
  return (
    <div>
      <h1 style={{fontSize:22,fontWeight:500,marginBottom:8}}>Good to see you, Taha</h1>
      <p style={{fontSize:14,color:'#888'}}>Select a tool from the sidebar to get started.</p>
    </div>
  );
}
